module.exports = __webpack_public_path__ + "static/media/flyer_exukonline_336x280.9228d89e.png";